import { motion } from "framer-motion";
import { SEO } from "../components/SEO";

export default function PrivacyPolicy() {
  return (
    <>
      <SEO title="Privacy Policy" description="Privacy policy and cookie consent information for aiwritingplatforms.com." />
      <section className="pt-36 pb-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-4">Legal</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="font-display font-black text-4xl text-white tracking-tight">Privacy Policy</motion.h1>
          <p className="text-zinc-500 text-sm mt-3">Last updated: January 2026</p>

          <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed">
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Information We Collect</h2>
              <p>When you subscribe to our AI Writing Prompts Library or otherwise opt in to our email list, we collect your email address and, optionally, your first name. We do not collect payment information, as this site does not sell products directly.</p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">How We Use Your Information</h2>
              <p>We use your email address to send the requested lead magnet and a related email sequence (typically 4 emails) covering AI writing tips, case studies, and occasional tool recommendations, some of which include affiliate links. You can unsubscribe at any time via the link in any email.</p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Cookies</h2>
              <p>We use cookies and similar technologies for basic site analytics (to understand which pages are useful) and to remember your preferences. You can disable cookies in your browser settings; core site functionality will continue to work.</p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Third-Party Links & Affiliate Disclosure</h2>
              <p>This site contains affiliate links to third-party AI writing tools. If you click through and make a purchase, we may earn a commission at no additional cost to you. See our <a href="/affiliate-disclosure" className="text-primary hover:text-[#5C7CFA]">Affiliate Disclosure</a> for full FTC-compliant details.</p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Data Retention & Your Rights</h2>
              <p>We retain subscriber data only as long as needed to operate our email list. You may request deletion of your data at any time by replying to any email or contacting us directly.</p>
            </div>
            <div>
              <h2 className="font-display font-bold text-xl text-white mb-3">Contact</h2>
              <p>Questions about this policy can be directed to the contact information listed in any of our email communications.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
